import axios from '@/utils/http';

export const fetchManualData = (options) => axios.request({
  ...options,
  url: '/api/mark/all/group/list',
  method: 'get',
});

export default {};



// WEBPACK FOOTER //
// ./src/api/module/manual.js